import React from "react";

const initState = {
    open: false,
    linkId: 0,
    linkName: "",
    pipelineStep: {},
};

const PipelineStepModalContext = React.createContext(initState);
export const usePipelineStepModalData = () =>
    React.useContext(PipelineStepModalContext);

const PipelineStepModalSwitchContext = React.createContext(() => {});
export const useSwitchPipelineStepModalData = () =>
    React.useContext(PipelineStepModalSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    return (
        <PipelineStepModalContext.Provider value={value}>
            <PipelineStepModalSwitchContext.Provider
                value={(value) => {
                    if (typeof value === "function") setValue(value);
                    else if (typeof value === "object")
                        setValue((state) => ({ ...state, ...value }));
                }}
            >
                {children}
            </PipelineStepModalSwitchContext.Provider>
        </PipelineStepModalContext.Provider>
    );
};
